<template>
  <div
      :style="{
        zoom: zoom,
        MozTransform: `scale(${zoom})`,
        WebkitTransform: `scale(${zoom})`,
        transformOrigin: 'left top',
      }"
  >
    <v-card
      v-if="config"
      elevation="2"
      class="main-template-preview" 
      :style="{ width: `${convertSize(config.originalWidth)}px`, height: `${convertSize(config.originalHeight)}px` }"
    >
      <div 
        :style="{ backgroundColor: '#CCCCCC80', width: `${convertSize(config.width)}px`, height: `${convertSize(config.height)}px` }"
        style="background-color: red !important;"
      >
        <zone
          v-for="(zone, index) of config.zones"
          v-show="hideZones.indexOf(zone.zoneID) < 0"
          :key="`new${config.presentationID}${zone.zoneID}`"
          :backgroundColor="zone.bgcolor"
          :color="zone.color"
          :fontSize="`${zone.textSize}px`"
          :top="zone.originalTop"
          :right="zone.originalRight"
          :width="zone.originalWidth"
          :height="zone.originalHeight"
          :originalWidth="zone.originalWidth"
          :originalHeight="zone.originalHeight"
          :scaleFactor="1"
          :zone="zone"
          :style="{ 
                    border: showInfo ? '1px solid red' : null,
                    'z-index': index 
                  }"
          :showInfo="showInfo"
          :onShowZone="handleShowZone"
          :onHideZone="handleHideZone"
          :onSendZoneMessage="handleSendZoneMessage"
          :zoneMessage="zoneMessage"
        />
      </div>
    </v-card>
  </div>
</template>
<script>
import Zone from './Zone'
export default {
  components: {
    Zone,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    hideZones: [],
    zoneMessage: null,
  }),
  computed: {
    showInfo () {
      return process.env.VUE_APP_ENV === 'development' ? true : false
    },
    zoom () {
      return 1
    },
  },
  mounted () {
  },
  methods: {
    convertSize (v) {
      if (!v) return v
      if (typeof v === 'string') return v.replace('px', '')
      return v
    },
    handleShowZone (v) {
      this.hideZones = this.hideZones.filter(x => x !== v)
    },
    handleHideZone (v) {
      if (this.hideZones.indexOf(v) < 0) this.hideZones.push(v)
    },
    handleSendZoneMessage (v) {
      this.zoneMessage = v
    },
  },
}
</script>
